// ═══════════════════════════════════════════════════════════════════════════════
// Receipt display date formatting for user-facing messages
// ═══════════════════════════════════════════════════════════════════════════════
import { LANGUAGE } from '../constants/index.js';
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
export const formatReceiptMismatchDateLabel = (dateStr, language) => {
    const trimmed = dateStr.trim();
    if (!ISO_DATE_RE.test(trimmed)) {
        return trimmed === '' ? '—' : trimmed;
    }
    if (language === LANGUAGE.EN || language === LANGUAGE.ID || language === LANGUAGE.FIL) {
        return trimmed;
    }
    const [year, month, day] = trimmed.split('-').map((part) => Number(part));
    return `${year}年${month}月${day}日`;
};
//# sourceMappingURL=receiptDisplayDate.js.map